import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `);

  const metaDescription = description || site.siteMetadata.description;

  // Note: I changed this from being a prop passed in to hardcoded
  const keywords = ['kansas city real estate', 'jonathan goforth', 'goforth team', 'goforth real estate', 'goforth real estate team', 'lees summit homes', 'goforth show', 'jonathan goforth show', 'youtube jonathan goforth show', 'how to sell homes in a tough market', 'overland park homes', 'overland park real estate', 'lees summit real estate', 'keller williams', 'platinum realty', 'goforth', 'blue springs homes', 'best realtor in kansas city', 'best realtor in overland park', 'best realtor in lees summit']

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string.isRequired,
};

export default SEO;
